export default __webpack_public_path__ + "static/media/banner-slot.0011feec.jpg";